import {
  Box,
  Center,
  Divider,
  Flex,
  HStack,
  Image,
  Portal,
  Text,
  useDisclosure
} from "@chakra-ui/react";
import React, { ChangeEvent, useEffect, useState } from "react";
import { GrAdd } from "react-icons/gr";
import { HiOutlinePencil } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import AdminDashboardHeader from "../../../components/admin/AdminHeader";
import AdminSidebar from "../../../components/admin/AdminSidebar";
import { AvailableCourseModal } from "../../../components/admin/AvailableCourseModal";
import { AdvertiseCourseModal } from "../../../components/admin/course/AdvertiseCourseModal";
import { AssignCourseModal } from "../../../components/admin/course/AssignCourseModal";
import { BulkCourseModal } from "../../../components/admin/course/BulkCourseModal";
import { CreateTechnicalityModal } from "../../../components/admin/course/CreateTechnicalityModal";
import { DeleteTechnicalityModal } from "../../../components/admin/course/DeleteTechnicalityModal";
import { UpdateTechnicalityModal } from "../../../components/admin/course/UpdateTechnicalityModal";
import Loading from "../../../components/common/Loading";
import delete_vector from "../../../img/deleteVectorRed.svg";
import { ICourse, ICourseType, Trainer } from "../../../models/course.model";
import AdminHelpers from "../../../services/admin/admin.service";
import coursesService from "../../../services/courses.service";
import registrationService from "../../../services/registration.service";
import Adminroutes from "../routes";

export const ExcelDataExport = [
  {
    "S/N": "1",
    "Course Title": " Example",
    "Course Type Code": "NTCH",
    "Program Category Code": "TMS",
    Cost: "20000",
    Discount: "1000",
    "Discount Type": "Rate",
    "Min Deposit": "0",
    "Number of Installment": "0",
    "Course Duration": "4",
    "Course Duration Unit": "Weeks",
    Status: "Draft/Published",
  },
];

const CourseTechnicality = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [courseAvailable, setAvailable] = useState(false);
  const [loading, setLoading] = useState(true);
  const [advertise, setAdvertise] = useState(false);
  const [assigncourse, setAssignCourse] = useState(false);
  const [deletecourse, setDeleteCourse] = useState(false);
  const [deletecoursetechnicality, setDeleteCourseTechnicality] =
    useState(false);
  const [reload, setReload] = useState(false);
  const [isBulkCourse, setIsBulkCourse] = useState(false);
  const [courseId, setCourseId] = useState("");
  const [technicalityId, setTechnicalityId] = useState("");
  const [courses, setCourses] = useState<ICourse[]>([]);
  const [trainers, setTrainers] = useState<Trainer[]>([]);
  const [trainerIds, setTrainerIds] = useState<string[]>();
  const [isSearchEmpty, setIsSearchEmpty] = useState(false);
  const [fileteredCourses, setFilteredCourses] = useState<ICourse[]>([]);

  const [course_types, setCourseTypes] = useState<ICourseType[]>([]);
  const [istechnicality, setistechnicality] = useState(false);
  const [isEdittechnicality, setisEdittechnicality] = useState(false);
  const [technicality, settechnicality] = useState<ICourseType>();

  const navigate = useNavigate();
  const viewCourse = async (course_id: string) => {
    navigate(Adminroutes.ACourseLink(course_id));
  };

  useEffect(() => {
    registrationService
      .getAllCourses()
      .then((response) => {
        const courses: ICourse[] = response;
                coursesService
          .getAvailableCourses()
          .then((res) => {
                        courses.forEach((each, ind) => {
              for (let index = 0; index < res.length; index++) {
                if (res[index].course_id == each.id) {
                  each.is_available = true;
                  break;
                } else {
                  each.is_available = false;
                }
              }
            });
            setCourses(
              courses.filter(
                (course) => course.status === 1 && course.is_program !== 1
              )
            );
            setFilteredCourses(
              courses.filter(
                (course) => course.status === 1 && course.is_program !== 1
              )
            );
          })
          .catch((err) => err);
        setTrainers(response.trainers);
        setLoading(false);
      })
      .catch((err) => err);

    AdminHelpers.getCourseTypes().then((res) => {
      setCourseTypes(res.data);
      setLoading(false);
    });
  }, [reload]);

  const opentechnicality = () => {
    setisEdittechnicality(false);
    setistechnicality(true);
  };

  const openEdittechnicality = (param: any) => {
    settechnicality(param);
    setisEdittechnicality(true);
    setistechnicality(false);
  };

  const openCourseAvailabilityModal = async (id: string) => {
    setAssignCourse(false);
    setDeleteCourse(false);
    setIsBulkCourse(false);
    setAvailable(true);
    setCourseId(id);
    setAdvertise(false);
    onOpen();
  };

  const openAssignCourseModal = async (id: string, trainers: Trainer[]) => {
    setAvailable(false);
    setAdvertise(false);
    setDeleteCourse(false);
    setIsBulkCourse(false);
    setAssignCourse(true);
    const ids: string[] = [];
    trainers.forEach((trainer) => ids.push(trainer.id.toString()));
    setTrainerIds(ids);
    setCourseId(id);
    onOpen();
  };

  const openAdvertiseCourseModal = async (id: string) => {
    setAvailable(false);
    setAssignCourse(false);
    setDeleteCourse(false);
    setIsBulkCourse(false);
    setCourseId(id);
    setAdvertise(true);
    onOpen();
  };

  // const openDeleteCourseModal = async (id: string) => {
  //   setAvailable(false);
  //   setAssignCourse(false);
  //   setAdvertise(false);
  //   setIsBulkCourse(false);
  //   setCourseId(id);
  //   setDeleteCourse(true);
  //   onOpen();
  // };

  const openDeleteTechnicalityModal = async (uuid: string) => {
    setAvailable(false);
    setAssignCourse(false);
    setAdvertise(false);
    setIsBulkCourse(false);
    setTechnicalityId(uuid);
    setDeleteCourseTechnicality(true);
    onOpen();
  };

  const bulkCourseModal = async () => {
    setAvailable(false);
    setAssignCourse(false);
    setAdvertise(false);
    setDeleteCourse(false);
    setIsBulkCourse(true);
    onOpen();
  };

  const reloadData = () => {
    setReload(!reload);
  };

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    if (!searchTerm) {
      setFilteredCourses(courses);
    } else {
      if (courses) {
        const filtered = courses.filter((each: any) =>
          each.name.toLowerCase().includes(searchTerm)
        );
        setFilteredCourses(filtered);
        if (filtered && filtered.length > 0) setIsSearchEmpty(false);
        else setIsSearchEmpty(true);
      }
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Box>
          <Flex         minHeight={"100vh"}
            height={"auto"}
            boxSizing="border-box"
            maxWidth={"100hw"}>
              <Box
              width={["4rem", "4rem", "4rem", "20%"]}
              position="relative"
              top="0"
              left="0"
              zIndex="100"
            >
              <AdminSidebar />
            </Box>

            <Box width="100%">
              <AdminDashboardHeader />
              <Box            pt="30px"
                px={["15px", "30px"]}
                width={"100%"}
                bg="#F9F8F8"
                height={"auto"}
                minHeight={"95vh"}
                maxHeight={"95vh"}
                overflowX={"scroll"}
                className="scroll-hidden">
                <Box
                  bg="white"
                  px="20px"
                  width={["95%","90%","80%","70%"]}
                  // maxWidth={"84%"}
                  py="50px"
                  right={0}
                  mx="auto"
                  boxShadow={"base"}
                  borderRadius={"5px"}
                >
                  <Text
                    color="#2B2B2B"
                    fontSize="27px"
                    fontWeight="700"
                    display="block"
                  >
                    Course Technicalities
                  </Text>
                  <>
                    {course_types.map((each, index) => (
                      <React.Fragment key={index}>
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                          py="26px"
                          // key={index}
                        >
                          <Box color="#616161" fontWeight="800" fontSize={["16px","16px","18px","18px"]}>
                            {each.name}
                          </Box>
                          <HStack spacing={2}>
                            <Center
                              border="1px solid"
                              borderRadius="10px"
                              onClick={() => {
                                openEdittechnicality(each);
                              }}
                              cursor={"pointer"}
                              borderColor="#E5E5E5"
                              width="30px"
                              height="30px"
                            >
                              <HiOutlinePencil />
                            </Center>
                            <Center
                              border="1px solid"
                              borderRadius="10px"
                              onClick={() => {
                                openDeleteTechnicalityModal(each.uuid);
                              }}
                              cursor={"pointer"}
                              borderColor="#E5E5E5"
                              width="30px"
                              height="30px"
                            >
                              <Image
                                src={delete_vector}
                                width="18px"
                                height="18px"
                              />
                            </Center>
                          </HStack>
                        </Flex>
                        {/* <Divider /> */}
                        {index !== course_types.length - 1 && <Divider />}
                      </React.Fragment>
                    ))}
                  </>

                  <Box
                    bgColor={"white"}
                    borderRadius={"1rem"}
                    border={"2px dotted #D9D9D9"}
                    padding={"1rem"}
                    marginBottom={"2.5rem"}
                    marginTop={"1.5rem"}
                    cursor="pointer"
                    onClick={() => {
                      opentechnicality();
                    }}
                  >
                    <Flex gap={"2.5rem"}>
                      <HStack justifyContent={"flex-start"} gap={"0.5rem"}>
                        <Center
                          border="1px solid"
                          borderRadius="10px"
                          cursor="pointer"
                          borderColor="#E5E5E5"
                          width="30px"
                          height="30px"
                        >
                          <GrAdd color="#00338D" />
                        </Center>

                        <Text fontSize={"14px"} textColor={"#616161"}>
                          Add a new course technicality
                        </Text>
                      </HStack>
                    </Flex>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Flex>
          {istechnicality && (
            <Portal>
              {" "}
              <CreateTechnicalityModal
                isOpentechnicality={istechnicality}
                onClosed={setistechnicality}
                istechnicality={istechnicality}
                reload={reloadData}
              />{" "}
            </Portal>
          )}
          {isEdittechnicality && (
            <Portal>
              {" "}
              <UpdateTechnicalityModal
                isOpenEdittechnicality={isEdittechnicality}
                onClosed={setisEdittechnicality}
                isEdittechnicality={isEdittechnicality}
                reload={reloadData}
                technicality={technicality}
              />{" "}
            </Portal>
          )}

          {courseAvailable && (
            <Portal>
              {" "}
              <AvailableCourseModal
                isOpens={isOpen}
                onCloses={onClose}
                courseId={courseId}
                updateRecord={reloadData}
              />{" "}
            </Portal>
          )}
          {advertise && (
            <Portal>
              {" "}
              <AdvertiseCourseModal
                isOpenAdvert={isOpen}
                onCloseAdvert={onClose}
                courseId={courseId}
                advertise={advertise}
                updateRecord={reloadData}
              />{" "}
            </Portal>
          )}

          {/* {deletecourse && (
            <Portal>
              {" "}
              <DeleteCourseModal
                isOpenDelete={isOpen}
                onCloseDelete={onClose}
                courseId={courseId}
                updateRecord={reloadData}
              />{" "}
            </Portal>
          )} */}
          {deletecoursetechnicality && (
            <Portal>
              {" "}
              <DeleteTechnicalityModal
                isOpenDelete={isOpen}
                onCloseDelete={onClose}
                // courseId={courseId}
                technicalityId={technicalityId}
                updateRecord={reloadData}
              />{" "}
            </Portal>
          )}

          {assigncourse && (
            <Portal>
              {" "}
              <AssignCourseModal
                isOpened={isOpen}
                onClosed={onClose}
                selectedCourseId={courseId}
                trainerIds={trainerIds}
                updateRecord={reloadData}
              />{" "}
            </Portal>
          )}

          {isBulkCourse && (
            <Portal>
              {" "}
              <BulkCourseModal
                isOpenBulk={isOpen}
                onClosed={onClose}
                isBulkCourse={isBulkCourse}
                reload={reloadData}
                isBatch={true}
              />{" "}
            </Portal>
          )}
        </Box>
      )}
    </>
  );
};

export default CourseTechnicality;
